import {
  fuseDetailConstants,
  createFuseConstants,
  editFuseConstants,
  countryListConstants,
  fuseKPISConstants,
} from "../_redux-constants";

export function fuseDetailReducer(
  state = {
    // Fuse Details
    fuseDetailLoading: false,
    fuseDetailData: null,
    fuseDetailError: null,

    // Create Fuse
    createFuseLoading: false,
    createFuseData: null,
    createFuseError: null,

    // Edit Fuse
    editFuseLoading: false,
    editFuseSuccess: false,
    editFuseError: null,

    // Country List
    countryListLoading: false,
    countryListData: [],
    countryListError: null,

    // KPIs
    fuseKPILoading: false,
    fuseKPIData: [],
    fuseKPIError: null,
  },
  action
) {
  // Fuse Details
  switch (action.type) {
    case fuseDetailConstants.FUSE_DETAIL_LOADING:
      return Object.assign({}, state, {
        fuseDetailLoading: true,
        fuseDetailData: null,
        fuseDetailError: null,
      });
    case fuseDetailConstants.FUSE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        fuseDetailLoading: false,
        fuseDetailData: action.data,
      });
    case fuseDetailConstants.FUSE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        fuseDetailLoading: false,
        fuseDetailData: null,
        fuseDetailError: action.error,
      });

    // Create Fuse
    case createFuseConstants.CREATE_FUSE_LOADING:
      return Object.assign({}, state, {
        createFuseLoading: true,
        createFuseError: null,
      });
    case createFuseConstants.CREATE_FUSE_SUCCESS:
      return Object.assign({}, state, {
        createFuseLoading: false,
        createFuseData: action.data,
      });
    case createFuseConstants.CREATE_FUSE_FAILURE:
      return Object.assign({}, state, {
        createFuseLoading: false,
        createFuseError: action.error,
      });
    case createFuseConstants.CLEAR_CREATE_FUSE:
      return Object.assign({}, state, {
        createFuseLoading: false,
        createFuseData: null,
        createFuseError: null,
      });

    // Edit Fuse
    case editFuseConstants.EDIT_FUSE_LOADING:
      return Object.assign({}, state, {
        editFuseLoading: true,
        createFuseError: null,
      });
    case editFuseConstants.EDIT_FUSE_SUCCESS:
      return Object.assign({}, state, {
        editFuseLoading: false,
        editFuseSuccess: true,
      });
    case editFuseConstants.EDIT_FUSE_FAILURE:
      return Object.assign({}, state, {
        editFuseLoading: false,
        editFuseError: action.error,
      });
    case createFuseConstants.CLEAR_EDIT_FUSE:
      return Object.assign({}, state, {
        editFuseLoading: false,
        editFuseSuccess: false,
        editFuseError: null,
      });

    // Country List
    case countryListConstants.COUNTRY_LIST_LOADING:
      return Object.assign({}, state, {
        countryListLoading: true,
        countryListError: null,
      });
    case countryListConstants.COUNTRY_LIST_SUCCESS:
      return Object.assign({}, state, {
        countryListLoading: false,
        countryListData: action.data,
      });
    case countryListConstants.COUNTRY_LIST_FAILURE:
      return Object.assign({}, state, {
        countryListLoading: false,
        countryListError: action.error,
      });

    // KPIs
    case fuseKPISConstants.FUSE_KPI_LOADING:
      return Object.assign({}, state, {
        fuseKPILoading: true,
        fuseKPIError: null,
      });
    case fuseKPISConstants.FUSE_KPI_SUCCESS:
      return Object.assign({}, state, {
        fuseKPILoading: false,
        fuseKPIData: action.data,
      });
    case fuseKPISConstants.FUSE_KPI_FAILURE:
      return Object.assign({}, state, {
        fuseKPILoading: false,
        fuseKPIError: action.error,
      });

    default:
      return state;
  }
}
